import classNames from 'classnames'
import * as React from 'react'

import {formatDuration} from '../../../../../utils/dateTimeUtils'
import Icon from '../../../../common/Icon/Icon'
import StopBuild from '../../../../common/StopBuild/StopBuild.container'

import type {Props} from './BuildOverviewProgress.types'

import styles from './BuildOverviewProgress.css'

const ONE_HUNDRED_PERCENT = 100
export default function BuildOverviewProgress({
  className,
  buildId,
  buildReady,
  elapsedSeconds,
  leftSeconds,
  overtimeSeconds,
  status,
  progress,
  showProgressLine,
  rounded,
  isOvertime,
}: Props) {
  const failed = status !== 'SUCCESS'
  return (
    <div
      className={classNames(className, styles.wrapper, {
        [styles.lineMargin]: showProgressLine,
        [styles.wrapperRounded]: rounded,
      })}
    >
      {buildReady && (
        <>
          {progress != null && !isNaN(progress) && progress > 0 && (
            <div
              className={classNames(styles.progress, {
                [styles.failedProgress]: failed,
              })}
              style={{
                width: `${progress}%`,
              }}
            >
              {showProgressLine === true && (
                <div
                  className={classNames(styles.line, {
                    [styles.lineFull]: progress >= ONE_HUNDRED_PERCENT,
                  })}
                />
              )}
            </div>
          )}
          <div className={styles.left}>
            {isOvertime && <Icon name="overtime" className={styles.overtimeIcon} />}
            {`Passed: ${formatDuration(elapsedSeconds, {alwaysShowSeconds: true})}`}
            {isOvertime && `, ${formatDuration(overtimeSeconds, {})} overtime`}
          </div>
          <div className={styles.right}>
            {!isOvertime &&
              leftSeconds != null &&
              leftSeconds > 0 &&
              `${formatDuration(leftSeconds, {})} left`}
            <StopBuild className={styles.stop} buildId={buildId} buttonText="Stop" primary />
          </div>
        </>
      )}
    </div>
  )
}
